import { batch, computed, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"

export const adminScrapingDataReviewFiltersSubmitted = signal({})
export const adminScrapingDataReviewPercentageData = signal({})
export const adminScrapingDataReviewTableData = signal([])

export const isModalVideo = signal(false)
export const adminScrapingDataReviewDetails = signal({})

export const adminScrapingDataReviewTableDataIndexed = computed(() => adminScrapingDataReviewTableData.value.reduce((acc, item) => {
    acc[item.id] = item
    return acc
}, {}))
export const adminScrapingDataReviewShowDetails = computed(() => !isEmpty(adminScrapingDataReviewDetails.value))

export const resetAdminScrapingDataReview = () => batch(() => {
    adminScrapingDataReviewTableData.value = []
    adminScrapingDataReviewDetails.value = {}
})